import React from 'react'
import { Switch } from 'react-router-dom'
import PropTypes from 'prop-types'

import HomePage from './Home'
import DetailPage from './Detail'
import PrivateRoute from '../../hocs/PrivateRoute'

/**
 * The car-request queue. The `:id` route is registered here rather than in DashboardRoutes, the way
 * Duty Conversations does it, so the section owns its own shape.
 */
const CarRequestRoutes = props => (
  <Switch>
    <PrivateRoute exact path={props.match.path} component={HomePage} />
    <PrivateRoute exact path={`${props.match.path}/:id`} component={DetailPage} />
  </Switch>
)

CarRequestRoutes.propTypes = {
  match: PropTypes.object
}

export default CarRequestRoutes
